(function (angular) {
	"use strict";

	function EditContactInfoForm(scope, user) {
		var self = this;
		var formName = "edit-contact-info-form";
        scope.hUser = user;
		var _protected = BaseForm.call(self, formName, scope);

        self.validator.validateCustom = function (field, optionsField, rule, showError) {

            var name = field.attr("name");

            switch (rule.name) {
                case "ssn":
                    var value = self.formData['info'] && self.formData['info'].ssn;
                    var ssn = value || "";
                    ssn = ssn.replace(/ /g, "").replace(/-/g, "");

                    if (ssn.length != 0  && (ssn.length != 9 || isNaN(ssn))) {
                        if (showError) {
                            self.validator.validation[name].errors[rule.name] = true;
                        }

                        return false;
                    }

                    break;
            }
            return true;
        }
            self.save = function () {
			var defer = $q.defer();

			if (self.validator.validate()) {

			    if (self.formData['locations'].length > 1) {
                    var counts = _.countBy(self.formData['locations'], function (loc) {
                        return loc.id;
                    });

                    for (var n in counts) {
                        if (counts[n] > 1) {
                            hAlert($filter("translate")("Error"), $filter("translate")("Duplicates found!"));
                            defer.reject({});
                            break;
                        }
                    }
                }
                else {
			        if (!self.formData['locations'][0]['id']) {
                        hAlert($filter("translate")("Error"), $filter("translate")("Cannot submit an empty location!"));
                        defer.reject({});
                    }
                }

                for (var l = self.formData['locations'].length - 1; l >= 0; l--) {
			        var loc = self.formData['locations'][l];
			        if (loc['id']) {
                        loc['is_primary'] = loc['id'] === parseInt(self.primary_location);
                        if (!loc['name']) {
                            var unassigned = _.findWhere(scope.unassignedLocations, {id: loc['id']});
                            loc['name'] = unassigned['name'];
                        }
                    } else {
			            self.formData['locations'].splice(l, 1);
                    }
                }

                if (self['google_location']) {
                    if (!self['google_location'].result) {
                        // This means that location was not changed by user
                        delete self['google_location'];
                    }
                    else {
                        self.formData['info']['location'] = self['google_location'].result;
                    }
                }
                if (_.isEmpty(self.formData['info']['location'])) {
                    delete self.formData['info']['location']
                } else {
                    if (!self.formData['info']['location'].result) {
                        self.formData['info']['location'] = {result: self.formData['info']['location']};
                    }
                }
				defer.resolve({contactInfo: self.formData['info'], activeLocations: self.formData['locations']});
			}
			else {
				defer.reject({});
			}

			return defer.promise;
		};

		/**
		 * load the data required for the form
		 * @param contactInfo
         * @param activeLocations
		 * @param addNewLocation
		 */
		self.load = function (contactInfo, activeLocations, addNewLocation, isActiveBrandMemberPrimary ) {
            scope.isActiveBrandMemberPrimary = isActiveBrandMemberPrimary;
			self.formData = {};
			self.formData['info'] = contactInfo;
            self.formData['locations'] = activeLocations;

            for (var l in self.formData['locations']) {
                if (self.formData['locations'][l]['is_primary']) {
                    self.primary_location = self.formData['locations'][l]['id'];
                    break;
                }
            }
            var formattedAddress;
            if (self.formData['info'] && self.formData['info'].location && self.formData['info'].location.result) {
                formattedAddress = self.formData['info'].location.result.formatted_address
            } else if (self.formData['info'].location && self.formData['info'].location.formatted_address) {
                formattedAddress = self.formData['info'].location.formatted_address;
            }

            self['google_location'] = {
                label: formattedAddress,
                value: {
                    result: {
                        formatted_address: formattedAddress,
                        geometry: {
                            lat:  undefined,
                            lng: undefined
                        },
                        same: true
                    }
                }
            };



			scope.isLoading = false;
            if (addNewLocation)
                self.addLocation();
            try {
                scope.$digest();
            } catch (e) {
            }
		};

        self.deleteLocation = function (index) {
            if (self.formData.locations.length !== 1) {
                self.formData.locations.splice(index, 1);
            }
            else {
                hAlert($filter("translate")("Error"), $filter("translate")("There must be at least one location!"));
            }
        };

        self.addLocation = function () {
            self.formData.locations = self.formData.locations || [];
            self.formData.locations.push({});
        };
	}

	angular
			.module('harriApp')
			.service('EditContactInfoForm', [function () {

				return function (scope) {
					return new EditContactInfoForm(scope);
				}
			}]);

})(angular);
